import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../components/GlobalCardComponent";
import { Box, Button, Grid, Menu, MenuItem, Typography } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomPopup from "../../../../components/customPopup/CustomPopup";
import EditGoal from "./EditGoal";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ConfimationPopup from "../../../../components/customPopup/ConfimationPopup";
import GlobalMessageModal from "../../../../components/customPopup/GlobalMessageModal";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import { useLocation } from "react-router-dom";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default function GoalTrackerCard({ testTypeList, goalLoading }) {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTestType, setSelectedTestType] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (testTypeList?.length > 0 && !selectedTestType) {
      setSelectedTestType(testTypeList[0]);
    }
  }, [testTypeList]);

  useEffect(() => {
    if (!selectedTestType) return;

    const moduleColors = {
      reading: "#DC9F52",
      listening: "#4F65DD",
      writing: "#1D860D",
      speaking: "#D81B60",

      analytical_writing: "#DC9F52",
      verbal_reasoning: "#4F65DD",
      quantitative_reasoning: "#1D860D",
      math: "#D81B60",
      data_insights: "#DC9F52",
      adaptive_test: "#DC9F52",
      video_interview: "#D81B60",
    };

    const modules = selectedTestType.module_list || [];

    const labels = modules.map((mod) =>
      mod.module_name.includes(" ")
        ? mod.module_name.split(" ")
        : mod.module_name
    );

    const values = modules.map((mod) => mod.value);
    const backgroundColors = modules.map(
      (mod) => moduleColors[mod.abbreviation] || "#CCCCCC"
    );

    setChartData({
      labels,
      datasets: [
        {
          data: values,
          backgroundColor: backgroundColors,
          hoverOffset: 4,
          borderRadius: 6,
          spacing: 6,
        },
      ],
    });
  }, [selectedTestType]);

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  const text = `${selectedTestType?.name ?? ""} Goal Successfully Updated !`;
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <CustomCardWithBorder height="100%" padding="15px">
            <Grid container>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    fontSize="20px"
                    color="#161719"
                    sx={{ fontWeight: 600, fontFamily: "Inter" }}
                  >
                    Goal Tracker
                  </Typography>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={1}
                  >
                    <Box>
                      <Button
                        variant="outlined"
                        onClick={handleClick}
                        endIcon={<ExpandMoreIcon />}
                        sx={{
                          borderRadius: "999px",
                          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "#fff",
                          color: "#572575",
                          borderColor: "#e0e0e0",
                          fontWeight: 500,
                          fontSize: "14px",
                          textTransform: "none",
                          fontFamily: "Inter",
                          px: 2,
                          py: 0.2,
                          "&:hover": {
                            backgroundColor: "#f8f8f8",
                            borderColor: "#ccc",
                          },
                        }}
                      >
                        {selectedTestType?.name}
                      </Button>
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{ "aria-labelledby": "dropdown-button" }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        {testTypeList?.map((type, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => {
                              setSelectedTestType(type);
                              handleClose();
                            }}
                          >
                            {type?.name}
                          </MenuItem>
                        ))}
                      </Menu>
                    </Box>

                    {selectedTestType?.avg_score !== 0 && (
                      <Box
                        sx={{ height: 20, width: 20 }}
                        onClick={handleOpenPopup}
                      >
                        <img
                          src="/newdashboard/ProfileSection/Group 1171284063.png"
                          style={{ cursor: "pointer" }}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>
              {goalLoading ? (
                <Grid item xs={12}>
                  <Loader height="20vh" text="Loading Goal..." />{" "}
                </Grid>
              ) : selectedTestType?.avg_score === 0 ? (
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    mt={4}
                  >
                    <Box sx={{width:76}}>
                      <img src="/newdashboard/Goal Tracke/Group 35889.png" />
                    </Box>
                    <Typography
                      fontWeight={600}
                      color="#313439"
                      mb={1}
                      mt={4}
                      fontFamily="Inter"
                      fontSize="18px"
                    >
                      Every success starts with a goal !
                    </Typography>
                    <Typography
                      fontWeight={400}
                      color="#313439"
                      mb={2}
                      fontFamily="Inter"
                      fontSize="12px"
                      lineHeight="1.4"
                      textAlign="center"
                    >
                      Define what you want to achieve — we’ll help you track it
                      step by step.
                    </Typography>

                    <Button
                      variant="contained"
                      onClick={handleOpenPopup}
                      sx={{
                        backgroundColor: "#572575",
                        color: "#FFFFFF",
                        borderRadius: "20px",

                        fontWeight: 700,
                        fontSize: "12px",
                        fontFamily: "Inter",
                        "&:hover": {
                          backgroundColor: "#d4bff1",
                        },
                      }}
                    >
                      Set Goal
                    </Button>
                  </Box>
                </Grid>
              ) : (
                // char section
                <Grid
                  item
                  xs={12}
                  mt={2}
                  display="flex"
                  justifyContent="center"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "350px",
                      height: 170,
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "330px",
                        height: 200,
                      }}
                    >
                      <Doughnut
                        data={chartData}
                        options={{
                          plugins: {
                            legend: { display: false },
                            tooltip: { enabled: false },
                            datalabels: {
                              color: "#3F424C",
                              font: {
                                size: 10,
                                weight: 600,
                                fontFamily: "Inter",
                              },
                              formatter: (value, ctx) =>
                                ctx.chart?.data?.labels[ctx.dataIndex],
                              anchor: "end",
                              align: "end",
                            },
                          },
                          rotation: -90,
                          circumference: 180,
                          cutout: "70%",
                          responsive: true,
                          maintainAspectRatio: false,
                          layout: {
                            padding: {
                              left: 50,
                              right: 50,
                            },
                          },
                        }}
                        plugins={[
                          {
                            id: "insideValues",
                            afterDatasetsDraw: (chart) => {
                              const { ctx } = chart;
                              const dataset = chart?.data?.datasets[0]?.data;
                              const meta = chart.getDatasetMeta(0);

                              meta.data.forEach((element, i) => {
                                const { x, y } = element.tooltipPosition();
                                ctx.save();
                                ctx.fillStyle = "#fff";
                                ctx.font = "bold 12px Inter";
                                ctx.textAlign = "center";
                                ctx.textBaseline = "middle";
                                ctx.fillText(dataset[i], x, y);
                                ctx.restore();
                              });
                            },
                          },
                        ]}
                      />

                      {/* Center Label */}
                      <Box
                        style={{
                          position: "absolute",
                          top: "55%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          color: "#572575",
                          fontWeight: 600,
                          fontSize: "14px",
                          background: "#FEFBF0",
                          padding: "8px 20px",
                          borderRadius: "20px",
                          pointerEvents: "none",
                          fontFamily: "Inter",
                          border: "1px solid #DDD8C7",
                        }}
                      >
                        {selectedTestType?.name || ""} (
                        {selectedTestType?.avg_score})
                      </Box>
                    </div>
                  </div>
                </Grid>
              )}
            </Grid>
          </CustomCardWithBorder>
        </Grid>
      </Grid>
      <CustomPopup
        handleClose={handleClosePopup}
        component={
          <EditGoal
            selectedTestType={selectedTestType}
            handleClose={handleClosePopup}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
            setSelectedTestType={setSelectedTestType}
          />
        }
        open={openPopup}
        subtitle=""
        title="Edit Your Goal"
        maxWidth="sm"
      />

      <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            const
            text={text}
            buttonTitle="View Goal"
            startIcon={<img src="/newdashboard/mage_goals-fill.png" />}
            navigateLink="/test-prep/testprepdashboard"
            currentLink={location.pathname}
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
